module.exports = __webpack_public_path__ + "img/DSF_logo.9f87ace1.png";